"use strict";

var $ = require("jquery");
var common = require("./common");
var uuid = require("./uuidMIT");


function InvalidTokenRegistration (params) {
    this.validUserWidgetInstance = params.validUserWidgetInstance;
    this.environment = params.environment;
    this.apigeeKey = params.apigeeKey;
    this.apiUrl = common.API_ENVIRONMENTS[this.environment] + '/pre-registration-request';
}

InvalidTokenRegistration.prototype.init = function (requestId) {
    var self = this;
    this.invalidTokenRegParent = this.validUserWidgetInstance.invalidRegTokenParent.find(".invalid-registration");
    this.clearErrorMessages();

    if(this.validUserWidgetInstance.token != null && this.validUserWidgetInstance.token != ""
        && this.validUserWidgetInstance.token != true)
    {
        common.showElement(this.invalidTokenRegParent.find("#token-invalid"));
    }

    this.emailField = this.invalidTokenRegParent.find("input#uim-uEmail-input");

    var submit = this.invalidTokenRegParent.find("input#uim-tokenInvalid-submit");

    var emailInputErrors = this.invalidTokenRegParent.find("#email-input-errors");
    this.fields = {
        email: this.emailField
    };
    this.validationState = {
        newEmail : false
    };

    this.emailField.on("blur", function () {
        self.validateEmail('blur');
    });

    this.emailField.on("keyup", function () {
        self.validateEmail('keyup');
    });

    submit.off("click enter");
    submit.on("click enter", function (e) {
        e.preventDefault();
        self.resendLink({
            email: self.fields.email.val(),
            requestId: requestId
        });
    });
};

InvalidTokenRegistration.prototype.isInputValid = function() {
    return this.validationState.newEmail;
};

InvalidTokenRegistration.prototype.updateSubmitState = function() {
    if(this.isInputValid() && !this.checkValidationErrors()) {
        this.invalidTokenRegParent.find("input#uim-tokenInvalid-submit").removeAttr('disabled');
    } else {
        this.invalidTokenRegParent.find("input#uim-tokenInvalid-submit").attr("disabled", true);
    }
};

InvalidTokenRegistration.prototype.checkValidationErrors = function() {
    var submitErrorsElement = this.invalidTokenRegParent.find("#tokenSubmit-errors");
    var emailInputErrorsElement = this.invalidTokenRegParent.find("#email-input-errors");
    return (
        common.checkElement(submitErrorsElement.find(".uim-message.unknown_server_error")) ||
        common.checkElement(emailInputErrorsElement.find(".uim-message.invalid-email-input")) ||
        common.checkElement(emailInputErrorsElement.find(".uim-message.empty-email-input")));
};

InvalidTokenRegistration.prototype.validateEmail = function(event) {
    var isValid = this.emailField[0].validity.valid;
    var emailInputErrorsElement = this.invalidTokenRegParent.find("#email-input-errors");

    this.validationState.newEmail = isValid;
    if (event === 'keyup' && isValid) {
        common.hideElement(emailInputErrorsElement.find(".uim-message.invalid-email-input"))
    }
    if (event === 'blur' && !isValid) {
        common.showElement(emailInputErrorsElement.find(".uim-message.invalid-email-input"))
    }

    this.updateSubmitState();
};

InvalidTokenRegistration.prototype.clearErrorMessages = function () {
    var submitErrorsElement = this.invalidTokenRegParent.find("#tokenSubmit-errors");

    common.hideElement(submitErrorsElement.find(".uim-message.unknown_server_error"));
};

InvalidTokenRegistration.prototype.showInputErrors = function (status) {
    var submitErrorsElement = this.invalidTokenRegParent.find("#tokenSubmit-errors");
    common.showElement(submitErrorsElement.find(".uim-message.unknown_server_error"));
};

InvalidTokenRegistration.prototype.showSuccessMsg = function () {
    if(this.validUserWidgetInstance.token != null && this.validUserWidgetInstance.token != "")
    {
        common.showElement(this.invalidTokenRegParent.find("#tokenInvalidSuccess"));
    }
};

InvalidTokenRegistration.prototype.resendLink = function(params){
    var self = this;
    $.ajax({
        method: "POST",
        url: this.apiUrl,
        data: JSON.stringify({
            data : {
                type : "pre-registration-request",
                attributes : {
                    emailAddress : self.fields.email.val()
                }
            }
        }),
        headers : {
            ApiKey : this.apigeeKey,
            "X-API-RequestId": params.requestId
        }
    }).success(function(data, status) {
        self.showSuccessMsg();
    }).error(function(xhr) {
        self.showInputErrors(xhr.status);
    });
};

module.exports = InvalidTokenRegistration;



//////////////////
// WEBPACK FOOTER
// ./components/ui-widgets/src/js/user-invalidTokenRegistration.js
// module id = 41
// module chunks = 0